export default __webpack_public_path__ + "static/media/img_profil.af72e0c7.png";